import React, { useEffect, useState } from 'react';
import { listOrganizations } from '../../../../services/organizationService';
import type { WizardState } from '../types';
import type { StepError } from '../validateStep';

interface Props {
  state: WizardState;
  onChange: (patch: Partial<WizardState>) => void;
  errors?: StepError[];
}

export default function OrganizationTierStep({ state, onChange, errors = [] }: Props) {
  const [orgs, setOrgs] = useState<any[]>([]);

  useEffect(() => {
    listOrganizations().then(setOrgs).catch(() => setOrgs([]));
  }, []);

  return (
    <div className="space-y-8">
      <section>
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Organization</h3>
        <p className="text-xs text-gray-500 mb-3">Select the parent organization for this department. Leave empty for standalone departments.</p>
        <select
          value={state.organizationId || ''}
          onChange={(e) => onChange({ organizationId: e.target.value || null })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
        >
          <option value="">No Organization (Standalone)</option>
          {orgs.map((o) => (
            <option key={o._id} value={o._id}>{o.name}</option>
          ))}
        </select>
      </section>

      <section>
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Subscription Tier</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { code: 'professional', name: 'Professional', desc: 'Core inspection management', color: 'blue' },
            { code: 'advanced', name: 'Advanced', desc: 'Custom roles, branding, federation', color: 'purple' },
            { code: 'premium', name: 'Premium', desc: 'Full platform with enterprise features', color: 'amber' },
          ].map((tier) => (
            <button
              key={tier.code}
              type="button"
              onClick={() => onChange({ tier: tier.code })}
              className={`p-4 rounded-xl border-2 text-left transition-all ${
                state.tier === tier.code
                  ? `border-${tier.color}-500 bg-${tier.color}-50 ring-2 ring-${tier.color}-200`
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className={`text-sm font-semibold ${state.tier === tier.code ? `text-${tier.color}-700` : 'text-gray-900'}`}>
                {tier.name}
              </div>
              <p className="text-xs text-gray-500 mt-1">{tier.desc}</p>
              {state.tier === tier.code && (
                <span className={`inline-block mt-2 text-xs font-medium text-${tier.color}-600`}>Selected</span>
              )}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
